import { Injectable } from '@angular/core';
import { ShepherdService } from 'angular-shepherd';
import { Router } from '@angular/router';
import { AjaxService } from './ajax.service';

@Injectable({
  providedIn: 'root'
})
export class TourService {

  constructor(public shepherdService: ShepherdService, private _router : Router, private _ajaxServices : AjaxService) {
    if (!this.shepherdService.isActive) {
      let defaultSteps =
      {
        classes: 'shepherd-theme-arrows',
        scrollTo: true,
        cancelIcon: {
          enabled: true
        }
      };
      this.shepherdService.modal = true;
      this.shepherdService.defaultStepOptions = defaultSteps;
      this.shepherdService.addSteps([
        {
          title: '<span class="font-semibold">Dashboard</span>',
          text: `<div class="text-sm">
                  Welcome to your system's dashboard. Continue the tour to see all of the potential components of a school's dashboard.
                </div>`,
          attachTo: {
            element: '.tour-step-1',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text shepherd-step-highlight',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next'
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Select School</span>',
          text: `<div class="text-sm">
                    Select / Change school.
                  </div>`,
          attachTo: {
            element: '.tour-step-2',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next'
            }
          ],
          id: 'creating'
        },
        {
          title: `<span class="font-semibold">Primary Assessment Data</span>`,
          text: `<div class="text-sm">
                    Displays <strong>'Reading'</strong> And <strong>'Math'</strong> proficiency data.
                  </div>`,
          attachTo: {
            element: '.tour-step-3',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next'
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Academic Growth/Performance Summary</span>',
          text: `<div class="text-sm">
                    Displays additional academic proficiency/growth data.\nMost systems will use this widget to highlight their school's academic growth measure.
                  </div>`,
          attachTo: {
            element: '.tour-step-4',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next'
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Flag Notifications</span>',
          text: `<div class="text-sm">
                    Displays flag Notifications for school.
                    <br />
                    <ul>
                      <li> <span class="rounded-full w-4 h-4 inline-block justify-end bg-green-600 "></span> Green Dot - School has achieved the expected goal</li>
                      <li> <span class="rounded-full w-4 h-4 inline-block justify-end bg-red-600 "></span> Red Dot - School hasn't yet achieved the expected goal</li>
                    </ul>
                  </div>`,
          attachTo: {
            element: '.tour-step-5',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next'
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Secondary Assessment Data</span>',
          text: `<div class="text-sm">
                    Displays secondary assessment breakdown.
                  </div>`,
          attachTo: {
            element: '.tour-step-6',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next'
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Enrollment Summary</span>',
          text: `<div class="text-sm">
                    Displays a school's enrollment for a 10 year period to monitor trends over time.
                  </div>`,
          attachTo: {
            element: '.tour-step-7',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              // action() {
              //   return this.next();
              // },
              text: 'Next',
              action: () => {
                this._router.navigate(['/annual-data']).then(() => {
                  this.shepherdService.next();
                });
              }
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Annual Data Target (ADT)</span>',
          text: `<div class="text-sm">
                    Provides a prioritized benchmark based on key data indicators from the dashboard.
                  </div>`,
          attachTo: {
            element: '.tour-step-8',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next',
              // action: () => {
              //   this._router.navigate(['/new-tab']).then(() => {
              //     this.shepherdService.next();
              //   });
              // }
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Suggested Annual Data Target (ADT)</span>',
          text: `<div class="text-sm">
                    The dashboard generates a suggested data target for each school based on the identified area of greatest need/concern
                  </div>`,
          attachTo: {
            element: '.tour-step-9',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next',
              // action: () => {
              //   this._router.navigate(['/new-tab']).then(() => {
              //     this.shepherdService.next();
              //   });
              // }
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Add ADT</span>',
          text: `<div class="text-sm">
                    Set a data target to address areas of concern/importance for your school school.
                  </div>`,
          attachTo: {
            element: '.tour-step-10',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              // action() {
              //   return this.next();
              // },
              text: 'Next',
              action: () => {
                this._router.navigate(['/assessment-plan']).then(() => {
                  this.shepherdService.next();
                });
              }
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Data & Assessment Plan</span>',
          text: `<div class="text-sm">
                    Provides a template to track and monitor important formative and summative assessments, classroom observations, surveys, etc.
                  </div>`,
          attachTo: {
            element: '.tour-step-11',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              // action() {
              //   return this.next();
              // },
              text: 'Next',
              action: () => {
                this._router.navigate(['/users']).then(() => {
                  this.shepherdService.next();
                });
              }
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Users</span>',
          text: `<div class="text-sm">
                    Add additional users to the dashboard - these additional users can access and interact with all aspects of the school dashboard.
                  </div>`,
          attachTo: {
            element: '.tour-step-12',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              action() {
                return this.next();
              },
              text: 'Next',
              // action: () => {
              //   this._router.navigate(['/users']).then(() => {
              //     this.shepherdService.next();
              //   });
              // }
            }
          ],
          id: 'creating'
        },
        {
          title: '<span class="font-semibold">Profile</span>',
          text: `<div class="text-sm">
                    Take tour again by clicking "Tour".
                  </div>`,
          attachTo: {
            element: '.tour-step-13',
            on: 'bottom'
          },
          classes: 'shepherd shepherd-open shepherd-theme-arrows shepherd-transparent-text',

          buttons: [
            {
              // action() {
              //   return this.next();
              // },
              text: 'Finish',
              action: () => {
                const user = JSON.parse(localStorage.getItem('CSIPUser') || '{}')
                user['showTour'] = 0
                localStorage.setItem('CSIPUser', JSON.stringify(user))
                this._ajaxServices.get(`users/deActivateTour/${user.id}`,).then((response: any) => {
                }).finally(() => {
                  this.shepherdService.complete();
                })
              }
            }
          ],
          id: 'creating'
        },
      ])
        
      this.shepherdService.modal = true;
      this.shepherdService.confirmCancel = false;
      
      
    }
  }
  startTour() {
    this.shepherdService.start();
  }

  handleCancel() {
    const user = JSON.parse(localStorage.getItem('CSIPUser') || '{}')
    user['showTour'] = 0
    localStorage.setItem('CSIPUser', JSON.stringify(user))
    this._ajaxServices.get(`users/deActivateTour/${user.id}`,).then((response: any) => {
    }).finally(() => {
      this.shepherdService.complete();
    })
  }
}
